module.exports = __webpack_public_path__ + "static/img/temper.f1638560.jpg";